import { createApp, type Component } from 'vue';
import { createPinia } from 'pinia';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { drupalSettingsData } from '@/helpers';

export const bootstrap = function(component: Component) {

	const app = createApp(component);

	const drupalSettings = drupalSettingsData();
	for( let setting in drupalSettings ) {
		app.provide(setting, drupalSettings[setting]);
	}
		
	const google_map_options = {
		key: drupalSettingsData()['google_maps_key'],
		libraries: 'places,geometry', //use geometry to get distance calculations etc
		language: drupalSettings.current_ladnguage ?? 'de',
	};

	app.use(createPinia())
		.use(VueGoogleMaps, {
			load: google_map_options,
			installComponents: false,
		})
		.mount(drupalSettingsData()['application_container']);
	
}
